import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { namesByRisk } from './selection';
import { TierCountPill, TierPillRow } from './styled_components';
import { Risk, ScopeFamily } from './types';

const t = withLocalePrefix('scope_tree');

const TIER_RISKS: Risk[] = ['view', 'warning', 'error'];

type ReadOnlyProps = {
  family: ScopeFamily;
  readOnly: true;
};

type EditableProps = {
  family: ScopeFamily;
  readOnly?: false;
  selected: Set<string>;
};

type Props = ReadOnlyProps | EditableProps;

export default function FamilyTierPills(props: Props) {
  const { family } = props;

  return (
    <TierPillRow>
      {TIER_RISKS.map((risk) => {
        const names = namesByRisk([family], [risk]);
        if (names.length === 0) {
          return null;
        }

        const tier = t(`bulk_actions.tiers.${risk}`);
        const label = props.readOnly
          ? t('family_tier_pill_total', { tier, total: names.length })
          : t('family_tier_pill', {
              tier,
              selected: names.filter((name) => props.selected.has(name)).length,
              total: names.length,
            });

        return (
          <TierCountPill key={risk} $risk={risk}>
            {label}
          </TierCountPill>
        );
      })}
    </TierPillRow>
  );
}
